import * as React from 'react';
import createIconComponent from '../createIconComponent.js';

var l = (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-testid": "Icon-minus-m" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 11.5H20V13H4V11.5Z", fill: "#101010" })));
var m = (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.3333 8.5L2.66663 8.50003L2.66663 7.50003L13.3333 7.5L13.3333 8.5Z", fill: "#101010" })));
var s = (React.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-testid": "Icon-minus-s" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.99998 6.5L2 6.50003L2 5.50003L9.99998 5.5L9.99998 6.5Z", fill: "#101010" })));
var Minus = createIconComponent({ l: l, m: m, s: s });

export { Minus as default };
//# sourceMappingURL=Minus.js.map
